var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loaders)?_c('div',{staticClass:"app-loader"},[_c('inline-svg',{attrs:{"src":require(`@/assets/svg/loading.svg`)}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }